import React, { createRef } from 'react';
import classnames from 'classnames';
import { Theme } from '@/sunzi';
import { i18n } from '@/utils';
import { Icon } from '..';
import styles from './style.less';

interface RotateVernierProps {
  /** 主题 */
	theme?: Theme;
  /** 监听放大 */
  onZoomIn(): void;
  /** 监听缩小 */
  onZoomOut(): void;
  /** 向左旋转 */
  onRotateLeft(): void;
  /** 向右旋转 */
  onRotateRight(): void;
  /** 游标变化监听 */
  onVernierChange(rotate: number): void;
}

class RotateVernier extends React.Component<RotateVernierProps> {
  private _vernier: React.RefObject<HTMLImageElement> = createRef();
  private _position = 0;

  componentDidMount() {
    if (this._vernier.current) {
      const { scrollWidth, clientWidth } = this._vernier.current;
      this._position = (scrollWidth - clientWidth - 6) / 2;
      this._vernier.current.scrollTo(this._position, 0);
    }
  }

  reset = () => {
		this._vernier.current?.scrollTo(this._position, 0);
  }

  onVernierScrollCapture = () => {
    const { onVernierChange } = this.props;
		if (this._vernier.current) {
			const { scrollLeft } = this._vernier.current;
			const rotate = (scrollLeft - this._position) / 6;
			onVernierChange(rotate);
		}
  }

  render() {
    const { onZoomIn, onZoomOut, onRotateLeft, onRotateRight, theme } = this.props;
    return (
      <div className={classnames(styles.rotateVernier, {
        [styles.rotateVernierLight]: theme === Theme.light
      })}>
        <div className={styles.rotateVernierContentWrapper}>
          <div className={styles.rotateVernierContent}>
            <div
              ref={this._vernier}
              onScrollCapture={this.onVernierScrollCapture}
              className={styles.vernierIndicatorWrapper}
            >
              <div className={styles.vernierIndicator}>
                {Array.from({ length: 180 }).map((_, index) => (
                  <div key={index} className={styles.vernierIndicatorItem}>
                    <span className={styles.vernierIndicatorItemValue}>
                      {index - 89 === 0 ? '•' : index - 89}
                    </span>
                    <div className={styles.vernierIndicatorItemLine} />
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.vernierCursor}>
              <div className={styles.vernierCursorLine} />
            </div>
          </div>
        </div>
        <div className={styles.rotateVernierFooter}>
          <div className={styles.iconWrapper} onClick={onZoomIn}>
            <Icon type="zoom-in" size={30} color="#fff" />
            <span>{i18n.format('components.footer.zoom.in')}</span>
          </div>
          <div className={styles.iconWrapper} onClick={onZoomOut}>
            <Icon type="zoom-out" size={30} color="#fff" />
            <span>{i18n.format('components.footer.zoom.out')}</span>
          </div>
          <div className={styles.iconWrapper} onClick={onRotateLeft}>
            <Icon type="rotate-left" size={30} color="#fff" />
            <span>{i18n.format('components.footer.rotate.left')}</span>
          </div>
          <div className={styles.iconWrapper} onClick={onRotateRight}>
            <Icon type="rotate-right" size={30} color="#fff" />
            <span>{i18n.format('components.footer.rotate.right')}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default RotateVernier;
